import { Component } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { MetaDataService } from '../metadata.service';
import { FAQService } from '../faq.service';
import { NGXLogger } from 'ngx-logger';

interface FaqItem {
  question: string;
  answer: string;
  isOpen: boolean;
}

@Component({
  selector: 'tea-shop-fe-frequently-asked-questions',
  standalone: false,
  templateUrl: './frequently-asked-questions.component.html',
  styleUrl: './frequently-asked-questions.component.css',
  animations: [
    trigger('expandCollapse', [
      state('collapsed', style({
        height: '0',
        opacity: '0',
        overflow: 'hidden'
      })),
      state('expanded', style({
        height: '*',
        opacity: '1'
      })),
      transition('collapsed <=> expanded', [
        animate('200ms ease-out')
      ])
    ])
  ]
})
export class FrequentlyAskedQuestionsComponent {
  areAllExpanded = false;
  isLoading = true;
  hasError = false;
  faqs: FaqItem[] = [];

  constructor(
    private metaDataService: MetaDataService,
    private faqService: FAQService,
    private logger: NGXLogger,
  ) {
    this.metaDataService.updateMetadata({
      title: 'Frequently Asked Questions',
      image: '/assets/contact/sencha-logo.png',
    });

    this.faqService.getFAQs().subscribe({
      next: (faqs) => {
        this.faqs = faqs
          .sort((a, b) => a.position - b.position)
          .map(faq => ({
            question: faq.question,
            answer: faq.answer,
            isOpen: false
          }));
        this.isLoading = false;
      },
      error: (error) => {
        this.logger.error('Error loading FAQs:', error);
        this.isLoading = false;
        this.hasError = true;
      }
    });
  }

  toggleAllFaqs(): void {
    this.areAllExpanded = !this.areAllExpanded;
    this.faqs.forEach(faq => faq.isOpen = this.areAllExpanded);
  }

  toggleFaq(faq: FaqItem): void {
    faq.isOpen = !faq.isOpen;
  }
}
